var module = angular.module('octopusApp.shared');
var avatarPlaceHolder = require("../../../img/users/avatar-placeholder.png");
var octopusServiceImage = require("../../../img/users/octopus-service-440.png");

module.directive('avatar', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      model: '=',
      size: '@'
    },
    template: '<div style="background-image: url(\'' + avatarPlaceHolder + '\'); background-size: 100%; width: 100%; height: 100%;">' +
                '<div ng-style="avatarStyle"></div>' +
              '</div>',
    link: function(scope, element, attrs) {
      scope.avatarStyle = { };

      var getStyle = function(addr, size) {
        if (!addr) {
          return { };
        }

        var suf = '';
        if (size) {
          suf = '&s=' + size;
        }

        var url = addr + suf;
        return {
          'background-image': 'url(\'' + url + '\')',
          'background-size': '100%',
          'width': '100%',
          'height': '100%'
        };
      };

      var update = function () {
        if (scope.model) {
          if (scope.model.IsService) {
            scope.avatarStyle = getStyle(octopusServiceImage, scope.size);
          } else if (scope.model.Links && scope.model.Links.Avatar) {
            scope.avatarStyle = getStyle(scope.model.Links.Avatar, scope.size);
          }
        }
      };

      scope.$watch("model.Links.Avatar", update);
      scope.$watch("model.IsService", update);

      update();
    }
  };
});







//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/avatar.js
// module id = 4046641005204818
// module chunks = 1